import { START_SAMPLE_SIGNATURE } from "../../graphql/skribble";

import { useMutation } from "@apollo/client";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";

import ScreenCard from "../ScreenCard";
import React, { useCallback, useState } from "react";

import WebViewWrapper from "../../components/WebViewWrapper";
import { isCancelEndUrls, isFailEndUrls, isSuccessEndUrls } from "../../skribble/helpers";

type SkribbleSampleScreenProps = StackScreenProps<RootStackParamList, "SkribbleSampleScreen">;

const SkribbleSampleScreen: React.FC<SkribbleSampleScreenProps> = ({ route, navigation }) => {
    const [startSampleSignature, { error, loading }] = useMutation(START_SAMPLE_SIGNATURE);
    const [webViewUrl, setWebViewUrl] = useState<string | null>(null);

    const onStartSampleSignature = useCallback(async () => {
        const { data } = await startSampleSignature();
        setWebViewUrl(data?.startSampleSignature?.signUrl || null);
    }, [startSampleSignature]);

    const onGoBack = useCallback(() => {
        navigation.goBack();
    }, [navigation]);

    return (
        <ScreenCard
            isContentContainerFlex
            buttons={[
                {
                    title: "Start signature",
                    mode: "primary",
                    onPress: onStartSampleSignature,
                    validating: loading,
                    isValid: !loading,
                },
                {
                    title: "Back",
                    mode: "outlined",
                    onPress: onGoBack,
                    validating: false,
                    isValid: true,
                },
            ]}
            headband={error ? { text: error.message, mode: "error" } : undefined}
        >
            {webViewUrl && (
                <WebViewWrapper
                    url={webViewUrl}
                    id="signing-frame"
                    enableBack
                    getDownloadFileName={() => {
                        return "dummy.pdf";
                    }}
                    onUrlChanged={(url) => {
                        // we log this to be able to display the url previously called
                        // as sentry does keep this information when generating a report
                        // eslint-disable-next-line no-console
                        console.log("Signing url changed --> ", `>${route.path}<`, url);
                        if (isSuccessEndUrls(url) || isCancelEndUrls(url) || isFailEndUrls(url)) {
                            // eslint-disable-next-line no-console
                            console.log("URL - CLOSED", {
                                success: isSuccessEndUrls(url),
                                end: isCancelEndUrls(url),
                                failure: isFailEndUrls(url),
                            });
                            setWebViewUrl(null);
                        }
                    }}
                />
            )}
        </ScreenCard>
    );
};

export default SkribbleSampleScreen;
